import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Link from "next/link";
import { IoArrowForward } from "react-icons/io5";
import * as s from "./index.module.scss";
import { PrismicRichText } from "@prismicio/react";
import secondaryFont from "@/utils/secondaryFont";
import Popups from "../../Common/Popups";
import useEmblaCarousel from "embla-carousel-react";

const Coins = ({ data, page }) => {
  const [showModal, setShowModal] = useState(false);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    loop: false,
  });

  return (
    <section className={`section-center ${s.coins}`}>
      <Container className={s.container_box}>
        <div className="embla__coins">
          <div className="embla__viewport" ref={emblaRef}>
            <div className="embla__container">
              {data?.coin.map(({ img, title, text, view_more_link }, index) => (
                <div className="embla__slide" key={index}>
                  <div className={s.box_swiper}>
                    <div>
                      <div className={s.box_img}>
                        <img
                          loading="lazy"
                          src={img.url}
                          alt={img.alt || "image"}
                          height="100%"
                        />
                      </div>
                      <div className={s.content_box_inside}>
                        <h5 className="fw-bold">{title}</h5>
                        <div className={`${secondaryFont} paragraph`}>
                          <PrismicRichText field={text || []} />
                        </div>
                        <div className={s.button_container}>
                          <button
                            className={`${secondaryFont} ${s.link}`}
                            onClick={() => {
                              setShowModal(true);
                            }}
                          >
                            Sell Now
                            <IoArrowForward
                              size="18px"
                              style={{ marginLeft: "8px" }}
                            />
                          </button>
                          <Link
                            className={`${secondaryFont} ${s.link}`}
                            href={view_more_link}
                          >
                            View More
                            <IoArrowForward
                              size="18px"
                              style={{ marginLeft: "8px" }}
                            />
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <Popups
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          page={page}
        />
      </Container>
    </section>
  );
};

export default Coins;
